import { render, staticRenderFns } from "./orderCard.vue?vue&type=template&id=3e553012&scoped=true&"
import script from "./orderCard.vue?vue&type=script&lang=js&"
export * from "./orderCard.vue?vue&type=script&lang=js&"
import style0 from "./orderCard.vue?vue&type=style&index=0&id=3e553012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e553012",
  null
  
)

export default component.exports